import { api } from "@/api/utils";
import { SupporterIdInput } from "@/components/forms/SupporterIdInput";
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { getErrorMessage } from "@/utils/error";
import { Box, Field, Label, toast } from "@givenwell/components";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Money, MoneyInput } from "../../../components/ui/MoneyInput";

export const Route = createFileRoute("/admin/devtools/")({
  component: DevTools,
});

function DevTools() {
  return (
    <Box css={{ spaceY: 16 }}>
      <SimulateDepositCard />
    </Box>
  );
}

function SimulateDepositCard() {
  const [supporterId, setSupporterId] = useState("");
  const [amount, setAmount] = useState<Money>({
    currencyCode: "nzd",
    cents: 0,
  });

  const mut = useMutation({
    mutationFn: async ({ supporterId }: { supporterId: string }) => {
      return await api.airWallex.simulateBankDeposit({
        supporterId,
        amount: amount.cents,
        currency: amount.currencyCode,
      });
    },
    onSuccess() {
      toast.success("Deposit successful!");
    },
    onError(error) {
      toast.error("Deposit failed", {
        description: getErrorMessage(error),
      });
    },
  });
  return (
    <Card title="Simulate deposit" css={{ w: "fit-content" }}>
      <form
        onSubmit={e => {
          e.preventDefault();
          if (!isFinite(Number(amount.cents))) {
            toast.error("Invalid amount");
            return;
          }
          mut.mutate({ supporterId });
        }}
      >
        <Box css={{ spaceY: 16 }}>
          <Field>
            <Label>Supporter</Label>
            <SupporterIdInput value={supporterId} onValueChange={setSupporterId} />
          </Field>
          <MoneyInput value={amount} onValueChange={setAmount} />

          <Button variant="tonal" type="submit" loading={mut.isPending}>
            Deposit
          </Button>
        </Box>
      </form>
    </Card>
  );
}
